import React from "react";

export const Departments = () => {
  return (
    <div>
      <h1 className="text-center">Department Page</h1>
    </div>
  );
};
